/**
 * The `ticket_event` payload for an FE's free-text comment: an internal work note on the work order task
 * (`add_worknote`, mapped to `wm_task.work_notes`). Kept pure so the wording can be tested without
 * ServiceNow. A work note has no priority field, so "Emergency" is carried as a prefix in the text.
 */
export const EMERGENCY_PREFIX = '[EMERGENCY] ';

export function buildCommentPayload(comment: string, emergency: boolean | null | undefined): { worknote: string } {
  const text = comment.trim();
  if (!text) throw new Error('A comment is required');
  return { worknote: emergency ? `${EMERGENCY_PREFIX}${text}` : text };
}
